import jwtDecode from "jwt-decode";
import ReactGA from "react-ga4";

export const jwtValidator = () => {
  if (localStorage.getItem("token")) {
    const decodedToken = jwtDecode(localStorage.getItem("token"));
    if (decodedToken.exp * 1000 < Date.now()) {
      localStorage.removeItem("token");
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
};

export const sendGAEvent = (type = "pageview", url = "") => {
  ReactGA.initialize("G-0R7CRD5VLC");
  ReactGA.send({
    hitType: type,
    page: url,
  });
};
